// Grace period banner component

import React from 'react';
import { AlertTriangle } from 'lucide-react';
import type { GracePeriod } from '../types';

interface GracePeriodBannerProps {
  gracePeriod: GracePeriod;
}

export function GracePeriodBanner({ gracePeriod }: GracePeriodBannerProps) {
  const endsAt = new Date(gracePeriod.endsAt * 1000);
  const hoursRemaining = Math.floor((endsAt.getTime() - Date.now()) / (1000 * 60 * 60));

  return (
    <div className="bg-orange-500/10 border border-orange-500/30 rounded-lg p-4 mb-5">
      <div className="flex items-center">
        <div className="flex-shrink-0">
          <AlertTriangle className="w-5 h-5 text-orange-400" />
        </div>
        <div className="ml-3">
          <h3 className="text-sm font-medium text-orange-300">License Key Rotation in Progress</h3>
          <p className="mt-1 text-sm text-orange-400/80">
            Your old license key will be revoked in <strong className="text-orange-300">{hoursRemaining} hours</strong>.
            Please update your Diosc installation with the new key shown above.
          </p>
        </div>
      </div>
    </div>
  );
}
